import {
  RedoDocumentationSchema,
  UpdateRedoDocumentationSchema,
} from "@redotech/redo-model/redo-documentation";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateRedoDocumentation = {
  name: "updateRedoDocumentation" as const,
  input: z.object({ id: zExt.objectId() }).merge(UpdateRedoDocumentationSchema),
  output: RedoDocumentationSchema.nullable(),
};
